export default {
    getTarrifList: (state) => {
        return state.tariff_list;
    },
    getBalanceModalIsOpen: (state) => {
        return state.balanceModalIsOpen;
    },
}